import React, { useState } from 'react';
import { db } from '../../firebase';
import { collectionGroup, query, where, getDocs, orderBy } from 'firebase/firestore';

const MedicationReportingTab = ({ serverId }) => {
    const [startDate, setStartDate] = useState(() => {
        const d = new Date();
        d.setMonth(d.getMonth() - 1);
        return d.toISOString().split('T')[0];
    });
    const [endDate, setEndDate] = useState(() => new Date().toISOString().split('T')[0]);
    const [isExporting, setIsExporting] = useState(false);

    const handleExportCSV = async () => {
        setIsExporting(true);
        try {
            const medsRef = collectionGroup(db, 'myMedications');
            
            // Note: In production with large datasets, you might need composite indexes 
            // for serverID + date and pagination.
            const start = new Date(startDate);
            start.setHours(0, 0, 0, 0);
            
            const end = new Date(endDate);
            end.setHours(23, 59, 59, 999);

            const q = query(
                medsRef, 
                where('serverID', '==', serverId),
                where('date', '>=', start),
                where('date', '<=', end),
                orderBy('date', 'desc')
            );
            
            const snap = await getDocs(q);
            const records = [];
            
            snap.forEach(doc => {
                records.push(doc.data());
            });
            
            if (records.length === 0) {
                alert("No medication records found for this date range.");
                return;
            }

            // Convert to CSV
            const headers = ['Date', 'User ID', 'Medication', 'Dose', 'Route', 'Status', 'Assigned By'];
            const rows = records.map(r => {
                const dateObj = r.createdAt?.seconds ? new Date(r.createdAt.seconds * 1000) : r.date?.seconds ? new Date(r.date.seconds * 1000) : new Date();
                return [
                    dateObj.toLocaleString().replace(/,/g, ''),
                    r.userID || 'Unknown',
                    `"${r.medicineName || r.medicationName || ''}"`,
                    r.dosage || '',
                    r.route || '',
                    r.status || 'Unknown',
                    r.assignedBy || ''
                ].join(',');
            });
            
            const csvContent = [headers.join(','), ...rows].join('\n');
            
            // Download file
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement("a");
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", `medication_report_${startDate}_to_${endDate}.csv`);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            
        } catch (err) {
            console.error("Export failed:", err);
            alert("Export failed: " + err.message);
        } finally {
            setIsExporting(false);
        }
    };

    return (
        <div>
            <h2 style={{ fontSize: '20px', color: '#2d3748', margin: '0 0 5px 0' }}>Medication Reporting</h2>
            <p style={{ color: '#718096', margin: '0 0 20px 0', fontSize: '14px' }}>Export medication administration logs and prescriptions to CSV.</p>

            <div style={{ padding: '20px', backgroundColor: 'white', borderRadius: '8px', border: '1px solid #e2e8f0', maxWidth: '600px' }}>
                <div style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>
                    <div style={{ flex: 1 }}>
                        <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', color: '#4a5568' }}>Start Date</label>
                        <input 
                            type="date" 
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                            style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #e2e8f0' }}
                        />
                    </div>
                    <div style={{ flex: 1 }}>
                        <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', color: '#4a5568' }}>End Date</label>
                        <input 
                            type="date" 
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                            style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #e2e8f0' }}
                        />
                    </div>
                </div>

                <button 
                    onClick={handleExportCSV}
                    disabled={isExporting}
                    style={{ padding: '12px 20px', backgroundColor: '#3182ce', color: 'white', border: 'none', borderRadius: '6px', fontWeight: 'bold', cursor: isExporting ? 'not-allowed' : 'pointer', width: '100%' }}
                >
                    {isExporting ? 'Generating Report...' : 'Export to CSV'}
                </button>
            </div>
        </div>
    );
};

export default MedicationReportingTab;
